/*!
This file is part of CycloneDX JavaScript Library.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

SPDX-License-Identifier: Apache-2.0
Copyright (c) OWASP Foundation. All Rights Reserved.
*/

import type { Comparable } from '../../_helpers/sortable'
import { SortableComparables } from '../../_helpers/sortable'
import type { Source } from './source'

/**
 * @privateRemarks
 * The model is built based on the JSON spec, which has all properties mandatory.
 * In contrast to the XML spec, which has them optional.
 * see https://github.com/CycloneDX/specification/issues/154
 */
export class Reference implements Comparable<Reference> {
  /**
   * @example values
   * - `CVE-2021-39182`
   * - `GHSA-35m5-8cvj-8783`
   * - `SNYK-PYTHON-ENROCRYPT-1912876`
   */
  id: string
  source: Source

  constructor (id: string, source: Source) {
    this.id = id
    this.source = source
  }

  compare (other: Reference): number {
    /* eslint-disable @typescript-eslint/strict-boolean-expressions -- run compares in weighted order */
    return this.id.localeCompare(other.id) ||
      this.source.compare(other.source)
    /* eslint-enable  @typescript-eslint/strict-boolean-expressions */
  }
}

export class ReferenceRepository extends SortableComparables<Reference> {}
